import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from '../ui/SectionHeading';
import { XCircle, CheckCircle2 } from 'lucide-react';
export function PackUpsell() {
  return <section className="py-12 md:py-24 px-4 md:px-8 bg-cream border-t border-brown/5" data-id="element-164">
      <div className="max-w-5xl mx-auto" data-id="element-165">
        <SectionHeading title="¿QUÉ AGREGA EL PACK COMPLETO?" subtitle="Para parejas que quieren seguir siendo equipo después de que nazca el bebé" data-id="element-166" />

        <div className="text-center mb-8 md:mb-12" data-id="element-167">
          <span className="font-serif text-lg md:text-xl text-terracotta font-bold" data-id="element-168">
            El embarazo termina, pero el equipo sigue
          </span>
          <span className="ml-2 md:ml-4 font-sans text-xs md:text-sm text-brown/40" data-id="element-169">
            01 / 02
          </span>
        </div>

        <div className="grid md:grid-cols-2 gap-4 md:gap-8 mb-10 md:mb-16" data-id="element-170">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-offwhite p-5 md:p-8 rounded-2xl border border-brown/10" data-id="element-171">
            <div className="flex items-center gap-2 md:gap-3 mb-3 md:mb-4 text-brown/60" data-id="element-172">
              <XCircle size={20} className="md:w-6 md:h-6" data-id="element-173" />
              <h4 className="font-serif font-bold text-base md:text-lg" data-id="element-174">
                Sin Pack Completo
              </h4>
            </div>
            <p className="font-sans text-sm md:text-base text-brown/80 leading-relaxed" data-id="element-175">
              Construyeron el equipo durante el embarazo, pero llegan al
              posparto sin herramientas para los primeros meses con el bebé — la
              etapa de mayor desgaste de pareja.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-terracotta/5 p-5 md:p-8 rounded-2xl border border-terracotta/20" data-id="element-176">
            <div className="flex items-center gap-2 md:gap-3 mb-3 md:mb-4 text-terracotta" data-id="element-177">
              <CheckCircle2 size={20} className="md:w-6 md:h-6" data-id="element-178" />
              <h4 className="font-serif font-bold text-base md:text-lg" data-id="element-179">
                Con Pack Completo
              </h4>
            </div>
            <p className="font-sans text-sm md:text-base text-brown/80 leading-relaxed" data-id="element-180">
              Dos tomos extra enfocados en el posparto: cómo sostener la
              conexión de pareja cuando llega el cansancio extremo, la falta de
              sueño y el reparto de tareas con el recién nacido.
            </p>
          </motion.div>
        </div>

        <div className="bg-brown text-offwhite rounded-3xl p-6 md:p-12" data-id="element-181">
          <h3 className="font-serif text-xl md:text-2xl font-bold mb-6 md:mb-8 text-center text-terracotta" data-id="element-182">
            EL PACK COMPLETO INCLUYE:
          </h3>

          <div className="grid md:grid-cols-2 gap-4 md:gap-6" data-id="element-183">
            <div className="flex gap-3 md:gap-4 items-center bg-offwhite/5 rounded-2xl p-3 md:p-4" data-id="element-184">
              <div className="relative w-16 h-16 md:w-20 md:h-20 rounded-xl overflow-hidden shrink-0" data-id="element-185">
                <img src="https://images.unsplash.com/photo-1546015720-b8b30df5aa27?auto=format&fit=crop&w=180&q=60" alt="Tomo 4 — Posparto: los primeros 90 días" loading="lazy" decoding="async" className="w-full h-full object-cover" data-id="element-186" />
                <span className="absolute bottom-0 left-0 bg-terracotta text-offwhite font-serif font-bold text-[10px] md:text-xs px-1.5 py-0.5 rounded-tr-lg" data-id="element-187">
                  T4
                </span>
              </div>
              <div className="min-w-0" data-id="element-188">
                <h4 className="font-serif font-bold text-base md:text-lg mb-0.5 md:mb-1 leading-tight" data-id="element-189">
                  Tomo 4 — Posparto: los primeros 90 días
                </h4>
                <p className="font-sans text-offwhite/70 text-xs md:text-sm leading-relaxed" data-id="element-190">
                  Cómo repartir tareas, sostener la intimidad y evitar que el
                  cansancio se vuelva distancia.
                </p>
              </div>
            </div>

            <div className="flex gap-3 md:gap-4 items-center bg-offwhite/5 rounded-2xl p-3 md:p-4" data-id="element-191">
              <div className="relative w-16 h-16 md:w-20 md:h-20 rounded-xl overflow-hidden shrink-0" data-id="element-192">
                <img src="https://images.unsplash.com/photo-1511895426328-dc8714191300?auto=format&fit=crop&w=180&q=60" alt="Tomo 5 — Equipo a largo plazo" loading="lazy" decoding="async" className="w-full h-full object-cover" data-id="element-193" />
                <span className="absolute bottom-0 left-0 bg-terracotta text-offwhite font-serif font-bold text-[10px] md:text-xs px-1.5 py-0.5 rounded-tr-lg" data-id="element-194">
                  T5
                </span>
              </div>
              <div className="min-w-0" data-id="element-195">
                <h4 className="font-serif font-bold text-base md:text-lg mb-0.5 md:mb-1 leading-tight" data-id="element-196">
                  Tomo 5 — Equipo a largo plazo
                </h4>
                <p className="font-sans text-offwhite/70 text-xs md:text-sm leading-relaxed" data-id="element-197">
                  Cómo seguir usando las herramientas de "De pareja a familia"
                  más allá del primer año.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}